import { apiRequest } from './client';

export function submitFeedback(message: string): Promise<void> {
  return apiRequest('/api/feedback', {
    method: 'POST',
    body: JSON.stringify({ message }),
  });
}
